import React, { useState, useRef, useEffect, useMemo } from 'react';
import { useLocale } from '../contexts/LocaleContext';
import { RotatingDeleteButton } from './RotatingDeleteButton';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';
import { iconIdMatchesSearchQuery } from './icon-picker-search';
import { FaPenNib } from "react-icons/fa";
import {
  MdMenuBook,
  MdBook,
  MdAutoStories,
  MdDescription,
  MdArticle,
  MdEditNote,
  MdDraw,
  MdCreate,
  MdBrush,
  MdPalette,
  MdStar,
  MdStarBorder,
  MdFavorite,
  MdFavoriteBorder,
  MdLightbulb,
  MdTipsAndUpdates,
  MdBolt,
  MdFlare,
  MdAutoAwesome,
  MdCastle,
  MdHome,
  MdCottage,
  MdApartment,
  MdLocationCity,
  MdForest,
  MdPark,
  MdWater,
  MdWaves,
  MdCloud,
  MdWbSunny,
  MdNightsStay,
  MdDarkMode,
  MdExplore,
  MdTravelExplore,
  MdMap,
  MdPublic,
  MdRocket,
  MdFlightTakeoff,
  MdSailing,
  MdDirectionsBoat,
  MdPsychology,
  MdSelfImprovement,
  MdTheaterComedy,
  MdMasks,
  MdMusicNote,
  MdPiano,
  MdMic,
  MdHeadphones,
  MdLocalFireDepartment,
  MdAcUnit,
  MdGrade,
  MdDiamond,
  MdWorkspacePremium,
  MdMilitaryTech,
  MdShield,
  MdSecurity,
  MdVpnKey,
  MdLock,
  MdVisibility,
  MdRemoveRedEye,
  MdFace,
  MdPeople,
  MdGroups,
  MdPets,
  MdBugReport,
  MdSmartToy,
  MdSportsEsports,
  MdExtension,
  MdCategory,
  MdHexagon,
  MdChangeHistory,
  MdCircle,
  MdSquare,
  MdBookmark,
  MdLabel,
  MdLocalOffer,
  MdFlag,
  MdOutlinedFlag,
  MdEdit,
  MdMode,
  MdHistoryEdu,
  MdDriveFileRenameOutline,
  MdBorderColor,
  MdFormatQuote,
  MdSubject,
  MdTextFields,
  MdTitle,
  MdNotes,
  MdStickyNote2,
  MdNote,
  MdNoteAlt,
  MdNoteAdd,
  MdFolder,
  MdFolderOpen,
  MdLibraryBooks,
  MdCollectionsBookmark,
  MdClass,
  MdChromeReaderMode,
  MdFeed,
  MdNewspaper,
  MdDesignServices,
  MdArchitecture,
  MdColorLens,
  MdGesture,
  MdFormatPaint,
  MdRecordVoiceOver,
  MdSpeakerNotes,
  MdChat,
  MdMessage,
  MdComment,
  MdRateReview,
  MdQuestionAnswer,
  MdForum,
  MdHistory,
  MdSchedule,
  MdEventNote,
  MdToday,
  MdCalendarToday,
  MdDateRange,
  MdSentimentSatisfied,
  MdSentimentDissatisfied,
  MdMood,
  MdMoodBad,
  MdEmojiEmotions,
  MdEmojiObjects,
  MdTerrain,
  MdLandscape,
  MdBeachAccess,
  MdFilterDrama,
  MdGrass,
  MdSearch,
  MdPolicy,
  MdFindInPage,
  MdDirectionsRun,
  MdVolunteerActivism,
  MdCardGiftcard,
  MdCake,
  MdCelebration,
  MdWarning,
  MdReportProblem,
  MdPriorityHigh,
  MdScience,
  MdBiotech,
  MdPrecisionManufacturing,
  MdPerson,
  MdPersonOutline,
  MdSupervisedUserCircle,
  MdEmojiPeople,
  MdChildCare,
  MdElderly,
  MdAccessibility,
  MdSportsKabaddi,
  MdFitnessCenter,
  MdPool,
  MdHiking,
  MdKitchen,
  MdRestaurant,
  MdLocalCafe,
  MdWineBar,
  MdNightlife,
  MdChurch,
  MdMosque,
  MdTempleHindu,
  MdSynagogue,
  MdAccountBalance,
  MdMuseum,
  MdTheaters,
  MdStadium,
  MdSchool,
  MdLocalHospital,
  MdLocalPolice,
  MdFireTruck,
  MdDirectionsCar,
  MdDirectionsBike,
  MdTrain,
  MdSubway,
  MdAirplanemodeActive,
  MdAnchor,
  MdSatelliteAlt,
  MdMemory,
  MdDeveloperBoard,
  MdElectricBolt,
  MdOfflineBolt,
  MdPowerSettingsNew,
  MdSettingsInputAntenna,
  MdCoronavirus,
  MdBloodtype,
  MdMonitorHeart,
  MdMedication,
  MdVaccines,
  MdPsychologyAlt,
  MdHealthAndSafety,
  MdCrisisAlert,
  MdWbTwilight,
  MdStorm,
  MdThunderstorm,
  MdSnowshoeing,
  MdSevereCold,
  MdWhatshot,
  MdLocalFlorist,
  MdYard,
  MdNaturePeople,
  MdNature,
  MdFilterVintage,
  MdSpa,
  MdSportsScore,
  MdEmojiEvents,
  MdLocalGasStation,
  MdRoute,
  MdStraight,
  MdLooksOne,
  MdLooksTwo,
  MdLooks3,
  MdLooks4,
  MdLooks5,
  MdLooks6,
  MdLooks,
  MdEmojiNature,
  MdEmojiFoodBeverage,
  MdEgg,
  MdEggAlt,
  MdOutdoorGrill,
  MdToc,
  MdViewList,
  MdListAlt,
  MdFormatListBulleted,
  MdFormatListNumbered,
  MdCheck,
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdCheckCircle,
  MdCheckCircleOutline,
  MdChecklist,
  MdChecklistRtl,
  MdAttachMoney,
  MdCurrencyExchange,
  MdAccountBalanceWallet,
  MdPayments,
  MdCreditCard,
  MdMonetizationOn,
  MdMoney,
  MdMoneyOff,
  MdSavings,
  MdPriceCheck,
  MdPriceChange,
  MdReceipt,
  MdReceiptLong,
  MdPointOfSale,
  MdShoppingCart,
  MdShoppingBag,
  MdStore,
  MdLocalAtm,
  MdTrendingUp,
  MdTrendingDown,
  MdShowChart,
  MdBarChart,
  MdPieChart,
} from 'react-icons/md';
import {
  PenTool,
  PenLine,
  Pencil,
  PencilLine,
  PencilRuler,
  Feather,
  Paintbrush,
  Palette,
  Brush,
  Highlighter,
  Eraser,
  BookOpen,
  BookOpenText,
  Book,
  BookMarked,
  BookText,
  BookCopy,
  BookA,
  BookHeart,
  BookUser,
  Library,
  LibraryBig,
  File,
  FileText,
  Newspaper,
  NotebookPen,
  NotebookText,
  NotebookTabs,
  StickyNote,
  NotepadText,
  NotepadTextDashed,
  ClipboardList,
  ClipboardPen,
  ClipboardCheck,
  ClipboardType,
  Folder,
  FolderOpen,
  FolderTree,
  FolderKanban,
  Archive,
  ArchiveRestore,
  Lightbulb,
  Sparkles,
  Wand2,
  WandSparkles,
  Zap,
  Flame,
  Star,
  StarHalf,
  Heart,
  HeartHandshake,
  Crown,
  Award,
  Medal,
  Trophy,
  Gem,
  Shield,
  ShieldCheck,
  ShieldAlert,
  Lock,
  LockOpen,
  Key,
  Eye,
  EyeOff,
  Home,
  House,
  Castle,
  Building,
  Building2,
  Warehouse,
  Tent,
  Landmark,
  Church,
  GraduationCap,
  School,
  Hospital,
  FerrisWheel,
  Trees,
  TreePine,
  Leaf,
  Flower,
  Flower2,
  Sprout,
  Cloud,
  CloudSun,
  CloudRain,
  CloudLightning,
  CloudSnow,
  Sun,
  SunMoon,
  Moon,
  MoonStar,
  Mountain,
  Waves,
  Droplet,
  Droplets,
  Thermometer,
  Wind,
  Snowflake,
  Umbrella,
  Palmtree,
  Compass,
  Map as MapIcon,
  MapPin,
  Globe,
  Rocket,
  Plane,
  PlaneTakeoff,
  Ship,
  Anchor,
  Sailboat,
  Car,
  Bike,
  Train,
  TrainFront,
  Bus,
  Fuel,
  Route,
  Signpost,
  Milestone,
  Footprints,
  Drama,
  VenetianMask,
  Theater,
  Music,
  Music2,
  Piano,
  Mic,
  Mic2,
  Headphones,
  Radio,
  PartyPopper,
  Gift,
  Users,
  User,
  UserRound,
  UserCircle,
  Baby,
  Cat,
  Dog,
  PawPrint,
  Handshake,
  Gamepad2,
  Puzzle,
  Dice5,
  Dices,
  Swords,
  Target,
  Crosshair,
  Hexagon,
  Octagon,
  Triangle,
  Circle,
  Square,
  Shapes,
  Bookmark,
  Tag,
  Tags,
  Flag,
  FlagTriangleRight,
  Quote,
  MessageSquare,
  MessageCircle,
  Send,
  Mail,
  Phone,
  Megaphone,
  History,
  Calendar,
  CalendarDays,
  CalendarClock,
  Clock,
  AlarmClock,
  Hourglass,
  Timer,
  Smile,
  Frown,
  Meh,
  Laugh,
  Angry,
  Annoyed,
  Search,
  Filter,
  AlertTriangle,
  AlertCircle,
  OctagonAlert,
  Info,
  FlaskConical,
  Microscope,
  Dna,
  Atom,
  Biohazard,
  Bug,
  Stethoscope,
  Pill,
  Syringe,
  HeartPulse,
  Activity,
  Brain,
  Dumbbell,
  Utensils,
  UtensilsCrossed,
  Coffee,
  Wine,
  Cake,
  Croissant,
  Beef,
  Egg,
  Fish,
  Soup,
  Cpu,
  Microchip,
  HardDrive,
  Server,
  Database,
  Wifi,
  Bluetooth,
  Satellite,
  BatteryCharging,
  Power,
  List,
  ListOrdered,
  ListChecks,
  Check,
  CheckCheck,
  CheckCircle,
  CheckSquare,
  ListTree,
  Banknote,
  Wallet,
  CreditCard,
  Coins,
  PiggyBank,
  Receipt,
  ShoppingCart,
  ShoppingBag,
  Store,
  TrendingUp,
  TrendingDown,
  BarChart,
  BarChart2,
  PieChart,
  LineChart,
} from 'lucide-react';

type IconComponent = (props: { className?: string; size?: number | string }) => React.ReactNode;

interface IconPickerProps {
  selectedIcon: string | null;
  onSelectIcon: (icon: string | null) => void;
  disabled?: boolean;
  size?: number;
  buttonSize?: number;
  fallbackIcon?: IconComponent;
}

interface IconDefinition {
  id: string;
  Icon: IconComponent;
}

// The picker only offers lucide icons going forward. The Md*/Fa* icons below are kept
// out of DOCUMENT_ICONS (so they no longer appear in the picker grid) but are still
// resolvable via getIconComponent so documents/projects that already picked one of
// these keep rendering their icon instead of going blank.
const LEGACY_DOCUMENT_ICONS: IconDefinition[] = [
  { id: 'FaPenNib', Icon: FaPenNib },
  { id: 'MdMenuBook', Icon: MdMenuBook },
  { id: 'MdBook', Icon: MdBook },
  { id: 'MdAutoStories', Icon: MdAutoStories },
  { id: 'MdDescription', Icon: MdDescription },
  { id: 'MdArticle', Icon: MdArticle },
  { id: 'MdEditNote', Icon: MdEditNote },
  { id: 'MdEdit', Icon: MdEdit },
  { id: 'MdHistoryEdu', Icon: MdHistoryEdu },
  { id: 'MdDriveFileRenameOutline', Icon: MdDriveFileRenameOutline },
  { id: 'MdBorderColor', Icon: MdBorderColor },
  { id: 'MdFormatQuote', Icon: MdFormatQuote },
  { id: 'MdSubject', Icon: MdSubject },
  { id: 'MdTextFields', Icon: MdTextFields },
  { id: 'MdTitle', Icon: MdTitle },
  { id: 'MdNotes', Icon: MdNotes },
  { id: 'MdStickyNote2', Icon: MdStickyNote2 },
  { id: 'MdNote', Icon: MdNote },
  { id: 'MdNoteAlt', Icon: MdNoteAlt },
  { id: 'MdNoteAdd', Icon: MdNoteAdd },
  { id: 'MdFolder', Icon: MdFolder },
  { id: 'MdFolderOpen', Icon: MdFolderOpen },
  { id: 'MdLibraryBooks', Icon: MdLibraryBooks },
  { id: 'MdCollectionsBookmark', Icon: MdCollectionsBookmark },
  { id: 'MdClass', Icon: MdClass },
  { id: 'MdChromeReaderMode', Icon: MdChromeReaderMode },
  { id: 'MdFeed', Icon: MdFeed },
  { id: 'MdNewspaper', Icon: MdNewspaper },
  { id: 'MdDraw', Icon: MdDraw },
  { id: 'MdCreate', Icon: MdCreate },
  { id: 'MdBrush', Icon: MdBrush },
  { id: 'MdPalette', Icon: MdPalette },
  { id: 'MdDesignServices', Icon: MdDesignServices },
  { id: 'MdArchitecture', Icon: MdArchitecture },
  { id: 'MdColorLens', Icon: MdColorLens },
  { id: 'MdGesture', Icon: MdGesture },
  { id: 'MdFormatPaint', Icon: MdFormatPaint },
  { id: 'MdRecordVoiceOver', Icon: MdRecordVoiceOver },
  { id: 'MdSpeakerNotes', Icon: MdSpeakerNotes },
  { id: 'MdChat', Icon: MdChat },
  { id: 'MdMessage', Icon: MdMessage },
  { id: 'MdComment', Icon: MdComment },
  { id: 'MdRateReview', Icon: MdRateReview },
  { id: 'MdQuestionAnswer', Icon: MdQuestionAnswer },
  { id: 'MdForum', Icon: MdForum },
  { id: 'MdStar', Icon: MdStar },
  { id: 'MdStarBorder', Icon: MdStarBorder },
  { id: 'MdFavorite', Icon: MdFavorite },
  { id: 'MdFavoriteBorder', Icon: MdFavoriteBorder },
  { id: 'MdLightbulb', Icon: MdLightbulb },
  { id: 'MdTipsAndUpdates', Icon: MdTipsAndUpdates },
  { id: 'MdBolt', Icon: MdBolt },
  { id: 'MdFlare', Icon: MdFlare },
  { id: 'MdAutoAwesome', Icon: MdAutoAwesome },
  { id: 'MdEmojiObjects', Icon: MdEmojiObjects },
  { id: 'MdPsychology', Icon: MdPsychology },
  { id: 'MdPsychologyAlt', Icon: MdPsychologyAlt },
  { id: 'MdSelfImprovement', Icon: MdSelfImprovement },
  { id: 'MdTheaterComedy', Icon: MdTheaterComedy },
  { id: 'MdMasks', Icon: MdMasks },
  { id: 'MdTheaters', Icon: MdTheaters },
  { id: 'MdSentimentSatisfied', Icon: MdSentimentSatisfied },
  { id: 'MdSentimentDissatisfied', Icon: MdSentimentDissatisfied },
  { id: 'MdMood', Icon: MdMood },
  { id: 'MdMoodBad', Icon: MdMoodBad },
  { id: 'MdEmojiEmotions', Icon: MdEmojiEmotions },
  { id: 'MdFace', Icon: MdFace },
  { id: 'MdPerson', Icon: MdPerson },
  { id: 'MdPersonOutline', Icon: MdPersonOutline },
  { id: 'MdPeople', Icon: MdPeople },
  { id: 'MdGroups', Icon: MdGroups },
  { id: 'MdSupervisedUserCircle', Icon: MdSupervisedUserCircle },
  { id: 'MdEmojiPeople', Icon: MdEmojiPeople },
  { id: 'MdChildCare', Icon: MdChildCare },
  { id: 'MdElderly', Icon: MdElderly },
  { id: 'MdAccessibility', Icon: MdAccessibility },
  { id: 'MdVolunteerActivism', Icon: MdVolunteerActivism },
  { id: 'MdCardGiftcard', Icon: MdCardGiftcard },
  { id: 'MdCake', Icon: MdCake },
  { id: 'MdCelebration', Icon: MdCelebration },
  { id: 'MdHistory', Icon: MdHistory },
  { id: 'MdSchedule', Icon: MdSchedule },
  { id: 'MdEventNote', Icon: MdEventNote },
  { id: 'MdToday', Icon: MdToday },
  { id: 'MdCalendarToday', Icon: MdCalendarToday },
  { id: 'MdDateRange', Icon: MdDateRange },
  { id: 'MdCastle', Icon: MdCastle },
  { id: 'MdHome', Icon: MdHome },
  { id: 'MdCottage', Icon: MdCottage },
  { id: 'MdApartment', Icon: MdApartment },
  { id: 'MdLocationCity', Icon: MdLocationCity },
  { id: 'MdAccountBalance', Icon: MdAccountBalance },
  { id: 'MdMuseum', Icon: MdMuseum },
  { id: 'MdSchool', Icon: MdSchool },
  { id: 'MdChurch', Icon: MdChurch },
  { id: 'MdMosque', Icon: MdMosque },
  { id: 'MdTempleHindu', Icon: MdTempleHindu },
  { id: 'MdSynagogue', Icon: MdSynagogue },
  { id: 'MdStadium', Icon: MdStadium },
  { id: 'MdLocalHospital', Icon: MdLocalHospital },
  { id: 'MdLocalPolice', Icon: MdLocalPolice },
  { id: 'MdFireTruck', Icon: MdFireTruck },
  { id: 'MdForest', Icon: MdForest },
  { id: 'MdPark', Icon: MdPark },
  { id: 'MdTerrain', Icon: MdTerrain },
  { id: 'MdLandscape', Icon: MdLandscape },
  { id: 'MdBeachAccess', Icon: MdBeachAccess },
  { id: 'MdGrass', Icon: MdGrass },
  { id: 'MdLocalFlorist', Icon: MdLocalFlorist },
  { id: 'MdYard', Icon: MdYard },
  { id: 'MdNaturePeople', Icon: MdNaturePeople },
  { id: 'MdNature', Icon: MdNature },
  { id: 'MdFilterVintage', Icon: MdFilterVintage },
  { id: 'MdSpa', Icon: MdSpa },
  { id: 'MdWater', Icon: MdWater },
  { id: 'MdWaves', Icon: MdWaves },
  { id: 'MdPool', Icon: MdPool },
  { id: 'MdAnchor', Icon: MdAnchor },
  { id: 'MdCloud', Icon: MdCloud },
  { id: 'MdFilterDrama', Icon: MdFilterDrama },
  { id: 'MdWbSunny', Icon: MdWbSunny },
  { id: 'MdWbTwilight', Icon: MdWbTwilight },
  { id: 'MdNightsStay', Icon: MdNightsStay },
  { id: 'MdDarkMode', Icon: MdDarkMode },
  { id: 'MdStorm', Icon: MdStorm },
  { id: 'MdThunderstorm', Icon: MdThunderstorm },
  { id: 'MdAcUnit', Icon: MdAcUnit },
  { id: 'MdSevereCold', Icon: MdSevereCold },
  { id: 'MdSnowshoeing', Icon: MdSnowshoeing },
  { id: 'MdWhatshot', Icon: MdWhatshot },
  { id: 'MdLocalFireDepartment', Icon: MdLocalFireDepartment },
  { id: 'MdExplore', Icon: MdExplore },
  { id: 'MdTravelExplore', Icon: MdTravelExplore },
  { id: 'MdMap', Icon: MdMap },
  { id: 'MdPublic', Icon: MdPublic },
  { id: 'MdHiking', Icon: MdHiking },
  { id: 'MdRocket', Icon: MdRocket },
  { id: 'MdFlightTakeoff', Icon: MdFlightTakeoff },
  { id: 'MdAirplanemodeActive', Icon: MdAirplanemodeActive },
  { id: 'MdSailing', Icon: MdSailing },
  { id: 'MdDirectionsBoat', Icon: MdDirectionsBoat },
  { id: 'MdDirectionsCar', Icon: MdDirectionsCar },
  { id: 'MdDirectionsBike', Icon: MdDirectionsBike },
  { id: 'MdTrain', Icon: MdTrain },
  { id: 'MdSubway', Icon: MdSubway },
  { id: 'MdSatelliteAlt', Icon: MdSatelliteAlt },
  { id: 'MdDirectionsRun', Icon: MdDirectionsRun },
  { id: 'MdSportsKabaddi', Icon: MdSportsKabaddi },
  { id: 'MdFitnessCenter', Icon: MdFitnessCenter },
  { id: 'MdSportsScore', Icon: MdSportsScore },
  { id: 'MdEmojiEvents', Icon: MdEmojiEvents },
  { id: 'MdMusicNote', Icon: MdMusicNote },
  { id: 'MdPiano', Icon: MdPiano },
  { id: 'MdMic', Icon: MdMic },
  { id: 'MdHeadphones', Icon: MdHeadphones },
  { id: 'MdNightlife', Icon: MdNightlife },
  { id: 'MdKitchen', Icon: MdKitchen },
  { id: 'MdRestaurant', Icon: MdRestaurant },
  { id: 'MdLocalCafe', Icon: MdLocalCafe },
  { id: 'MdWineBar', Icon: MdWineBar },
  { id: 'MdSearch', Icon: MdSearch },
  { id: 'MdPolicy', Icon: MdPolicy },
  { id: 'MdFindInPage', Icon: MdFindInPage },
  { id: 'MdVisibility', Icon: MdVisibility },
  { id: 'MdRemoveRedEye', Icon: MdRemoveRedEye },
  { id: 'MdWarning', Icon: MdWarning },
  { id: 'MdReportProblem', Icon: MdReportProblem },
  { id: 'MdPriorityHigh', Icon: MdPriorityHigh },
  { id: 'MdCrisisAlert', Icon: MdCrisisAlert },
  { id: 'MdScience', Icon: MdScience },
  { id: 'MdBiotech', Icon: MdBiotech },
  { id: 'MdPrecisionManufacturing', Icon: MdPrecisionManufacturing },
  { id: 'MdMemory', Icon: MdMemory },
  { id: 'MdDeveloperBoard', Icon: MdDeveloperBoard },
  { id: 'MdElectricBolt', Icon: MdElectricBolt },
  { id: 'MdOfflineBolt', Icon: MdOfflineBolt },
  { id: 'MdPowerSettingsNew', Icon: MdPowerSettingsNew },
  { id: 'MdSettingsInputAntenna', Icon: MdSettingsInputAntenna },
  { id: 'MdCoronavirus', Icon: MdCoronavirus },
  { id: 'MdBloodtype', Icon: MdBloodtype },
  { id: 'MdMonitorHeart', Icon: MdMonitorHeart },
  { id: 'MdMedication', Icon: MdMedication },
  { id: 'MdVaccines', Icon: MdVaccines },
  { id: 'MdHealthAndSafety', Icon: MdHealthAndSafety },
  { id: 'MdGrade', Icon: MdGrade },
  { id: 'MdDiamond', Icon: MdDiamond },
  { id: 'MdWorkspacePremium', Icon: MdWorkspacePremium },
  { id: 'MdMilitaryTech', Icon: MdMilitaryTech },
  { id: 'MdShield', Icon: MdShield },
  { id: 'MdSecurity', Icon: MdSecurity },
  { id: 'MdVpnKey', Icon: MdVpnKey },
  { id: 'MdLock', Icon: MdLock },
  { id: 'MdPets', Icon: MdPets },
  { id: 'MdBugReport', Icon: MdBugReport },
  { id: 'MdSmartToy', Icon: MdSmartToy },
  { id: 'MdSportsEsports', Icon: MdSportsEsports },
  { id: 'MdExtension', Icon: MdExtension },
  { id: 'MdCategory', Icon: MdCategory },
  { id: 'MdHexagon', Icon: MdHexagon },
  { id: 'MdChangeHistory', Icon: MdChangeHistory },
  { id: 'MdCircle', Icon: MdCircle },
  { id: 'MdSquare', Icon: MdSquare },
  { id: 'MdBookmark', Icon: MdBookmark },
  { id: 'MdLabel', Icon: MdLabel },
  { id: 'MdLocalOffer', Icon: MdLocalOffer },
  { id: 'MdFlag', Icon: MdFlag },
  { id: 'MdOutlinedFlag', Icon: MdOutlinedFlag },
  { id: 'MdLocalGasStation', Icon: MdLocalGasStation },
  { id: 'MdRoute', Icon: MdRoute },
  { id: 'MdStraight', Icon: MdStraight },
  { id: 'MdLooksOne', Icon: MdLooksOne },
  { id: 'MdLooksTwo', Icon: MdLooksTwo },
  { id: 'MdLooks3', Icon: MdLooks3 },
  { id: 'MdLooks4', Icon: MdLooks4 },
  { id: 'MdLooks5', Icon: MdLooks5 },
  { id: 'MdLooks6', Icon: MdLooks6 },
  { id: 'MdLooks', Icon: MdLooks },
  { id: 'MdEmojiNature', Icon: MdEmojiNature },
  { id: 'MdEmojiFoodBeverage', Icon: MdEmojiFoodBeverage },
  { id: 'MdEgg', Icon: MdEgg },
  { id: 'MdEggAlt', Icon: MdEggAlt },
  { id: 'MdOutdoorGrill', Icon: MdOutdoorGrill },
  { id: 'MdToc', Icon: MdToc },
  { id: 'MdViewList', Icon: MdViewList },
  { id: 'MdListAlt', Icon: MdListAlt },
  { id: 'MdFormatListBulleted', Icon: MdFormatListBulleted },
  { id: 'MdFormatListNumbered', Icon: MdFormatListNumbered },
  { id: 'MdCheck', Icon: MdCheck },
  { id: 'MdCheckBox', Icon: MdCheckBox },
  { id: 'MdCheckBoxOutlineBlank', Icon: MdCheckBoxOutlineBlank },
  { id: 'MdCheckCircle', Icon: MdCheckCircle },
  { id: 'MdCheckCircleOutline', Icon: MdCheckCircleOutline },
  { id: 'MdChecklist', Icon: MdChecklist },
  { id: 'MdChecklistRtl', Icon: MdChecklistRtl },
  { id: 'MdAttachMoney', Icon: MdAttachMoney },
  { id: 'MdCurrencyExchange', Icon: MdCurrencyExchange },
  { id: 'MdAccountBalanceWallet', Icon: MdAccountBalanceWallet },
  { id: 'MdPayments', Icon: MdPayments },
  { id: 'MdCreditCard', Icon: MdCreditCard },
  { id: 'MdMonetizationOn', Icon: MdMonetizationOn },
  { id: 'MdMoney', Icon: MdMoney },
  { id: 'MdMoneyOff', Icon: MdMoneyOff },
  { id: 'MdSavings', Icon: MdSavings },
  { id: 'MdPriceCheck', Icon: MdPriceCheck },
  { id: 'MdPriceChange', Icon: MdPriceChange },
  { id: 'MdReceipt', Icon: MdReceipt },
  { id: 'MdReceiptLong', Icon: MdReceiptLong },
  { id: 'MdPointOfSale', Icon: MdPointOfSale },
  { id: 'MdShoppingCart', Icon: MdShoppingCart },
  { id: 'MdShoppingBag', Icon: MdShoppingBag },
  { id: 'MdStore', Icon: MdStore },
  { id: 'MdLocalAtm', Icon: MdLocalAtm },
  { id: 'MdTrendingUp', Icon: MdTrendingUp },
  { id: 'MdTrendingDown', Icon: MdTrendingDown },
  { id: 'MdShowChart', Icon: MdShowChart },
  { id: 'MdBarChart', Icon: MdBarChart },
  { id: 'MdPieChart', Icon: MdPieChart },
];

const DOCUMENT_ICONS: IconDefinition[] = [
  { id: 'PenTool', Icon: PenTool },
  { id: 'PenLine', Icon: PenLine },
  { id: 'Pencil', Icon: Pencil },
  { id: 'PencilLine', Icon: PencilLine },
  { id: 'PencilRuler', Icon: PencilRuler },
  { id: 'Feather', Icon: Feather },
  { id: 'Paintbrush', Icon: Paintbrush },
  { id: 'Palette', Icon: Palette },
  { id: 'Brush', Icon: Brush },
  { id: 'Highlighter', Icon: Highlighter },
  { id: 'Eraser', Icon: Eraser },
  { id: 'BookOpen', Icon: BookOpen },
  { id: 'BookOpenText', Icon: BookOpenText },
  { id: 'Book', Icon: Book },
  { id: 'BookMarked', Icon: BookMarked },
  { id: 'BookText', Icon: BookText },
  { id: 'BookCopy', Icon: BookCopy },
  { id: 'BookA', Icon: BookA },
  { id: 'BookHeart', Icon: BookHeart },
  { id: 'BookUser', Icon: BookUser },
  { id: 'Library', Icon: Library },
  { id: 'LibraryBig', Icon: LibraryBig },
  { id: 'File', Icon: File },
  { id: 'FileText', Icon: FileText },
  { id: 'Newspaper', Icon: Newspaper },
  { id: 'NotebookPen', Icon: NotebookPen },
  { id: 'NotebookText', Icon: NotebookText },
  { id: 'NotebookTabs', Icon: NotebookTabs },
  { id: 'StickyNote', Icon: StickyNote },
  { id: 'NotepadText', Icon: NotepadText },
  { id: 'NotepadTextDashed', Icon: NotepadTextDashed },
  { id: 'ClipboardList', Icon: ClipboardList },
  { id: 'ClipboardPen', Icon: ClipboardPen },
  { id: 'ClipboardCheck', Icon: ClipboardCheck },
  { id: 'ClipboardType', Icon: ClipboardType },
  { id: 'Folder', Icon: Folder },
  { id: 'FolderOpen', Icon: FolderOpen },
  { id: 'FolderTree', Icon: FolderTree },
  { id: 'FolderKanban', Icon: FolderKanban },
  { id: 'Archive', Icon: Archive },
  { id: 'ArchiveRestore', Icon: ArchiveRestore },
  { id: 'Lightbulb', Icon: Lightbulb },
  { id: 'Sparkles', Icon: Sparkles },
  { id: 'Wand2', Icon: Wand2 },
  { id: 'WandSparkles', Icon: WandSparkles },
  { id: 'Zap', Icon: Zap },
  { id: 'Flame', Icon: Flame },
  { id: 'Star', Icon: Star },
  { id: 'StarHalf', Icon: StarHalf },
  { id: 'Heart', Icon: Heart },
  { id: 'HeartHandshake', Icon: HeartHandshake },
  { id: 'Crown', Icon: Crown },
  { id: 'Award', Icon: Award },
  { id: 'Medal', Icon: Medal },
  { id: 'Trophy', Icon: Trophy },
  { id: 'Gem', Icon: Gem },
  { id: 'Shield', Icon: Shield },
  { id: 'ShieldCheck', Icon: ShieldCheck },
  { id: 'ShieldAlert', Icon: ShieldAlert },
  { id: 'Lock', Icon: Lock },
  { id: 'LockOpen', Icon: LockOpen },
  { id: 'Key', Icon: Key },
  { id: 'Eye', Icon: Eye },
  { id: 'EyeOff', Icon: EyeOff },
  { id: 'Home', Icon: Home },
  { id: 'House', Icon: House },
  { id: 'Castle', Icon: Castle },
  { id: 'Building', Icon: Building },
  { id: 'Building2', Icon: Building2 },
  { id: 'Warehouse', Icon: Warehouse },
  { id: 'Tent', Icon: Tent },
  { id: 'Landmark', Icon: Landmark },
  { id: 'Church', Icon: Church },
  { id: 'GraduationCap', Icon: GraduationCap },
  { id: 'School', Icon: School },
  { id: 'Hospital', Icon: Hospital },
  { id: 'FerrisWheel', Icon: FerrisWheel },
  { id: 'Trees', Icon: Trees },
  { id: 'TreePine', Icon: TreePine },
  { id: 'Leaf', Icon: Leaf },
  { id: 'Flower', Icon: Flower },
  { id: 'Flower2', Icon: Flower2 },
  { id: 'Sprout', Icon: Sprout },
  { id: 'Cloud', Icon: Cloud },
  { id: 'CloudSun', Icon: CloudSun },
  { id: 'CloudRain', Icon: CloudRain },
  { id: 'CloudLightning', Icon: CloudLightning },
  { id: 'CloudSnow', Icon: CloudSnow },
  { id: 'Sun', Icon: Sun },
  { id: 'SunMoon', Icon: SunMoon },
  { id: 'Moon', Icon: Moon },
  { id: 'MoonStar', Icon: MoonStar },
  { id: 'Mountain', Icon: Mountain },
  { id: 'Waves', Icon: Waves },
  { id: 'Droplet', Icon: Droplet },
  { id: 'Droplets', Icon: Droplets },
  { id: 'Thermometer', Icon: Thermometer },
  { id: 'Wind', Icon: Wind },
  { id: 'Snowflake', Icon: Snowflake },
  { id: 'Umbrella', Icon: Umbrella },
  { id: 'Palmtree', Icon: Palmtree },
  { id: 'Compass', Icon: Compass },
  { id: 'Map', Icon: MapIcon },
  { id: 'MapPin', Icon: MapPin },
  { id: 'Globe', Icon: Globe },
  { id: 'Rocket', Icon: Rocket },
  { id: 'Plane', Icon: Plane },
  { id: 'PlaneTakeoff', Icon: PlaneTakeoff },
  { id: 'Ship', Icon: Ship },
  { id: 'Anchor', Icon: Anchor },
  { id: 'Sailboat', Icon: Sailboat },
  { id: 'Car', Icon: Car },
  { id: 'Bike', Icon: Bike },
  { id: 'Train', Icon: Train },
  { id: 'TrainFront', Icon: TrainFront },
  { id: 'Bus', Icon: Bus },
  { id: 'Fuel', Icon: Fuel },
  { id: 'Route', Icon: Route },
  { id: 'Signpost', Icon: Signpost },
  { id: 'Milestone', Icon: Milestone },
  { id: 'Footprints', Icon: Footprints },
  { id: 'Drama', Icon: Drama },
  { id: 'VenetianMask', Icon: VenetianMask },
  { id: 'Theater', Icon: Theater },
  { id: 'Music', Icon: Music },
  { id: 'Music2', Icon: Music2 },
  { id: 'Piano', Icon: Piano },
  { id: 'Mic', Icon: Mic },
  { id: 'Mic2', Icon: Mic2 },
  { id: 'Headphones', Icon: Headphones },
  { id: 'Radio', Icon: Radio },
  { id: 'PartyPopper', Icon: PartyPopper },
  { id: 'Gift', Icon: Gift },
  { id: 'Users', Icon: Users },
  { id: 'User', Icon: User },
  { id: 'UserRound', Icon: UserRound },
  { id: 'UserCircle', Icon: UserCircle },
  { id: 'Baby', Icon: Baby },
  { id: 'Cat', Icon: Cat },
  { id: 'Dog', Icon: Dog },
  { id: 'PawPrint', Icon: PawPrint },
  { id: 'Handshake', Icon: Handshake },
  { id: 'Gamepad2', Icon: Gamepad2 },
  { id: 'Puzzle', Icon: Puzzle },
  { id: 'Dice5', Icon: Dice5 },
  { id: 'Dices', Icon: Dices },
  { id: 'Swords', Icon: Swords },
  { id: 'Target', Icon: Target },
  { id: 'Crosshair', Icon: Crosshair },
  { id: 'Hexagon', Icon: Hexagon },
  { id: 'Octagon', Icon: Octagon },
  { id: 'Triangle', Icon: Triangle },
  { id: 'Circle', Icon: Circle },
  { id: 'Square', Icon: Square },
  { id: 'Shapes', Icon: Shapes },
  { id: 'Bookmark', Icon: Bookmark },
  { id: 'Tag', Icon: Tag },
  { id: 'Tags', Icon: Tags },
  { id: 'Flag', Icon: Flag },
  { id: 'FlagTriangleRight', Icon: FlagTriangleRight },
  { id: 'Quote', Icon: Quote },
  { id: 'MessageSquare', Icon: MessageSquare },
  { id: 'MessageCircle', Icon: MessageCircle },
  { id: 'Send', Icon: Send },
  { id: 'Mail', Icon: Mail },
  { id: 'Phone', Icon: Phone },
  { id: 'Megaphone', Icon: Megaphone },
  { id: 'History', Icon: History },
  { id: 'Calendar', Icon: Calendar },
  { id: 'CalendarDays', Icon: CalendarDays },
  { id: 'CalendarClock', Icon: CalendarClock },
  { id: 'Clock', Icon: Clock },
  { id: 'AlarmClock', Icon: AlarmClock },
  { id: 'Hourglass', Icon: Hourglass },
  { id: 'Timer', Icon: Timer },
  { id: 'Smile', Icon: Smile },
  { id: 'Frown', Icon: Frown },
  { id: 'Meh', Icon: Meh },
  { id: 'Laugh', Icon: Laugh },
  { id: 'Angry', Icon: Angry },
  { id: 'Annoyed', Icon: Annoyed },
  { id: 'Search', Icon: Search },
  { id: 'Filter', Icon: Filter },
  { id: 'AlertTriangle', Icon: AlertTriangle },
  { id: 'AlertCircle', Icon: AlertCircle },
  { id: 'OctagonAlert', Icon: OctagonAlert },
  { id: 'Info', Icon: Info },
  { id: 'FlaskConical', Icon: FlaskConical },
  { id: 'Microscope', Icon: Microscope },
  { id: 'Dna', Icon: Dna },
  { id: 'Atom', Icon: Atom },
  { id: 'Biohazard', Icon: Biohazard },
  { id: 'Bug', Icon: Bug },
  { id: 'Stethoscope', Icon: Stethoscope },
  { id: 'Pill', Icon: Pill },
  { id: 'Syringe', Icon: Syringe },
  { id: 'HeartPulse', Icon: HeartPulse },
  { id: 'Activity', Icon: Activity },
  { id: 'Brain', Icon: Brain },
  { id: 'Dumbbell', Icon: Dumbbell },
  { id: 'Utensils', Icon: Utensils },
  { id: 'UtensilsCrossed', Icon: UtensilsCrossed },
  { id: 'Coffee', Icon: Coffee },
  { id: 'Wine', Icon: Wine },
  { id: 'Cake', Icon: Cake },
  { id: 'Croissant', Icon: Croissant },
  { id: 'Beef', Icon: Beef },
  { id: 'Egg', Icon: Egg },
  { id: 'Fish', Icon: Fish },
  { id: 'Soup', Icon: Soup },
  { id: 'Cpu', Icon: Cpu },
  { id: 'Microchip', Icon: Microchip },
  { id: 'HardDrive', Icon: HardDrive },
  { id: 'Server', Icon: Server },
  { id: 'Database', Icon: Database },
  { id: 'Wifi', Icon: Wifi },
  { id: 'Bluetooth', Icon: Bluetooth },
  { id: 'Satellite', Icon: Satellite },
  { id: 'BatteryCharging', Icon: BatteryCharging },
  { id: 'Power', Icon: Power },
  { id: 'List', Icon: List },
  { id: 'ListOrdered', Icon: ListOrdered },
  { id: 'ListChecks', Icon: ListChecks },
  { id: 'Check', Icon: Check },
  { id: 'CheckCheck', Icon: CheckCheck },
  { id: 'CheckCircle', Icon: CheckCircle },
  { id: 'CheckSquare', Icon: CheckSquare },
  { id: 'ListTree', Icon: ListTree },
  { id: 'Banknote', Icon: Banknote },
  { id: 'Wallet', Icon: Wallet },
  { id: 'CreditCard', Icon: CreditCard },
  { id: 'Coins', Icon: Coins },
  { id: 'PiggyBank', Icon: PiggyBank },
  { id: 'Receipt', Icon: Receipt },
  { id: 'ShoppingCart', Icon: ShoppingCart },
  { id: 'ShoppingBag', Icon: ShoppingBag },
  { id: 'Store', Icon: Store },
  { id: 'TrendingUp', Icon: TrendingUp },
  { id: 'TrendingDown', Icon: TrendingDown },
  { id: 'BarChart', Icon: BarChart },
  { id: 'BarChart2', Icon: BarChart2 },
  { id: 'PieChart', Icon: PieChart },
  { id: 'LineChart', Icon: LineChart },
];

const ICON_MAP = new Map<string, IconComponent>(
  DOCUMENT_ICONS.map(({ id, Icon }) => [id, Icon])
);

const LEGACY_ICON_MAP = new Map<string, IconComponent>(
  LEGACY_DOCUMENT_ICONS.map(({ id, Icon }) => [id, Icon])
);

export const getIconComponent = (iconId: string | null): IconComponent | null => {
  if (!iconId) return null;
  return ICON_MAP.get(iconId) || LEGACY_ICON_MAP.get(iconId) || null;
};

const getIconDisplayName = (iconId: string): string => {
  const withoutPrefix = iconId.replace(/^Md/, '');
  const words = withoutPrefix.replace(/([A-Z])/g, ' $1').trim();
  return words.charAt(0).toUpperCase() + words.slice(1).toLowerCase();
};

export const IconPicker: React.FC<IconPickerProps> = ({
  selectedIcon,
  onSelectIcon,
  disabled = false,
  size = 32,
  buttonSize,
  fallbackIcon,
}) => {
  const { t } = useLocale();
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const searchInputRef = useRef<HTMLInputElement>(null);

  const filteredIcons = useMemo(() => {
    if (!searchQuery.trim()) return DOCUMENT_ICONS;
    return DOCUMENT_ICONS.filter(({ id }) => iconIdMatchesSearchQuery(id, searchQuery));
  }, [searchQuery]);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => searchInputRef.current?.focus(), 0);
    }
  }, [isOpen]);

  const handleOpenChange = (open: boolean): void => {
    if (disabled) {
      return;
    }
    setIsOpen(open);
    if (!open) {
      setSearchQuery('');
    }
  };

  const handleIconClick = (iconId: string): void => {
    onSelectIcon(iconId);
    setIsOpen(false);
    setSearchQuery('');
  };

  const handleRemoveIcon = (): void => {
    onSelectIcon(null);
    setIsOpen(false);
    setSearchQuery('');
  };

  const SelectedIconComponent = (selectedIcon ? getIconComponent(selectedIcon) : null) || fallbackIcon || null;
  const resolvedButtonSize = buttonSize ?? size + 8;

  return (
    <Popover open={isOpen} onOpenChange={handleOpenChange}>
      <PopoverTrigger asChild>
        <button
          type="button"
          disabled={disabled}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: `${resolvedButtonSize}px`,
            height: `${resolvedButtonSize}px`,
            boxSizing: 'border-box',
            backgroundColor: SelectedIconComponent ? 'transparent' : 'var(--card)',
            border: SelectedIconComponent ? 'none' : '1px dashed var(--border)',
            borderRadius: '8px',
            cursor: disabled ? 'not-allowed' : 'pointer',
            transition: 'all 0.2s',
            opacity: disabled ? 0.5 : 1,
            color: SelectedIconComponent ? 'var(--foreground)' : 'var(--muted-foreground)',
            padding: SelectedIconComponent ? '4px' : '0',
          }}
          onMouseEnter={(e) => {
            if (!disabled) {
              if (SelectedIconComponent) {
                e.currentTarget.style.backgroundColor = 'rgba(59, 130, 246, 0.1)';
              } else {
                e.currentTarget.style.borderColor = 'var(--border)';
                e.currentTarget.style.backgroundColor = 'var(--muted)';
              }
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = SelectedIconComponent ? 'transparent' : 'var(--card)';
            if (!SelectedIconComponent) {
              e.currentTarget.style.borderColor = 'var(--border)';
            }
          }}
          title={selectedIcon ? t('change_icon') : t('add_icon')}
        >
          {SelectedIconComponent && <SelectedIconComponent size={size} />}
        </button>
      </PopoverTrigger>

      <PopoverContent
        align="start"
        side="bottom"
        sideOffset={4}
        className="w-80 p-3"
        data-testid="icon-picker-panel"
        onOpenAutoFocus={(event) => {
          event.preventDefault();
          searchInputRef.current?.focus();
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.5rem',
          }}
        >
          <input
            ref={searchInputRef}
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder={t('search_icon')}
            style={{
              flex: 1,
              padding: '0.5rem 0.75rem',
              border: '1px solid var(--border)',
              borderRadius: '4px',
              fontSize: '0.875rem',
              outline: 'none',
              backgroundColor: 'var(--background)',
              color: 'var(--foreground)',
            }}
            onFocus={(e) => {
              e.currentTarget.style.borderColor = 'var(--scribane-black)';
            }}
            onBlur={(e) => {
              e.currentTarget.style.borderColor = 'var(--border)';
            }}
          />
          {selectedIcon && (
            <RotatingDeleteButton
              onClick={handleRemoveIcon}
              tooltipText={t('remove_icon')}
              className="p-0"
            />
          )}
        </div>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(8, 1fr)',
            gap: '4px',
            maxHeight: '280px',
            overflowY: 'auto',
          }}
        >
          {filteredIcons.map(({ id, Icon }) => (
            <button
              key={id}
              type="button"
              onClick={() => handleIconClick(id)}
              title={getIconDisplayName(id)}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '32px',
                height: '32px',
                backgroundColor: selectedIcon === id ? 'var(--scribane-black)' : 'transparent',
                color: selectedIcon === id ? '#fff' : 'var(--foreground)',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                transition: 'all 0.15s',
              }}
              onMouseEnter={(e) => {
                if (selectedIcon !== id) {
                  e.currentTarget.style.backgroundColor = 'var(--muted)';
                }
              }}
              onMouseLeave={(e) => {
                if (selectedIcon !== id) {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }
              }}
            >
              <Icon size={20} />
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
